import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_DASHBOARD,
  RECEIVE_DASHBOARD
} from '../actions/dashboard'

export default handleActions({
  [REQUEST_DASHBOARD]: (state, action) => ({isFetching: true}),
  [RECEIVE_DASHBOARD]: (state, action) => {
    const { dashboard } = action.payload.data

    state = update(state, {
      $set: {
        events: dashboard.events,
        riders: dashboard.riders,
        riderRequests: dashboard.rider_requests
      }
    })

    return state
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js